<template>
  <div :class="classCompany" @click="onClick(vendor)">
    <div class="card-header-company">
      <div class="card-header-frame-company">
        <div class="btn-card-share" @click.stop="copyToClipboard(vendor.id)">
          <img :src="require(`~/assets/img/icons/share.png`)" alt="" />
        </div>
        <div class="card-header-image-company">
          <div class="circle">
            <img :src="`${api}/file/${vendor.logo}`" alt="" v-if="vendor && vendor.logo" />
            <div :class="checkTotalInitial(vendor.nama_vendor) < 3
                ? 'initial'
                : `initial${checkTotalInitial(vendor.nama_vendor)}`
              " v-else>
              {{ generateInitial(vendor.nama_vendor) }}
            </div>
          </div>
          <!-- <img :src="require(`~/assets/img/asana.png`)" alt="" v-else /> -->
        </div>
        <div class="card-header-company-description">
          <div class="text-bold">{{ vendor.nama_vendor }}</div>
          <div>
            <span class="text-bold">{{ vendor.alias_profile }} - </span><span>{{ afiliationClass(vendor) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-content-company">
      <div class="card-content-company-wrapper">
        <div class="text-bold">Kinerja PO</div>
        <div class="rating-wrapper">
          <div>
            <span :class="kinerjaPoRating(vendor.csi_score_avg, 1)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaPoRating(vendor.csi_score_avg, 2)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaPoRating(vendor.csi_score_avg, 3)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaPoRating(vendor.csi_score_avg, 4)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaPoRating(vendor.csi_score_avg, 5)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
          </div>
        </div>
      </div>
      <div class="card-content-company-wrapper">
        <div class="text-bold">Kinerja Kontrak</div>
        <div class="rating-wrapper">
          <div>
            <span :class="kinerjaKontrakRating(vendor.grade, 1)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaKontrakRating(vendor.grade, 2)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaKontrakRating(vendor.grade, 3)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaKontrakRating(vendor.grade, 4)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
            <span :class="kinerjaKontrakRating(vendor.grade, 5)
                ? 'star-active'
                : 'star-deactive'
              ">&#9733;</span>
          </div>
        </div>
      </div>
      <div class="card-content-company-wrapper">
        <div class="text-bold">K3L</div>
        <div :style="{ color: isK3lExpired(vendor.latest_tanggal_berakhir_k3l) ? 'red' : '' }">
          {{ vendor.latest_k3l }} {{ $getK3lCategories(vendor.latest_k3l) }}
        </div>
      </div>
      <div class="card-content-company-wrapper">
        <div class="text-bold">KPLH</div>
        <div :style="{ color: isKplhExpired(vendor.latest_tanggal_berakhir_kplh) ? 'red' : '' }">
          {{ vendor.latest_kplh }}
          {{
            vendor.keterangan_kplh == 'TIDAK LULUS PRAQUALIFIKASI'
            ? 'TIDAK LULUS'
            : vendor.latest_resiko
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api, api_main } from '../../services/config'

export default {
  props: [
    'onClick',
    'id',
    'csiScore',
    'companyName',
    'grade',
    'k3lValue',
    'k3lDesc',
    'kplhValue',
    'kplhDesc',
    'afiliated',
    'badanUsaha',
    'logo',
    'vendor',
    'classCompany',
  ],
  data() {
    return {
      api: api_main,
    }
  },
  created() { },
  methods: {
    isKplhExpired(data) {
      console.log('is Kplh Exp: ==', data);
      if (!data) return false;
      const today = new Date();
      const expirationDate = new Date(data);
      console.log('kplh expired date', expirationDate);
      return expirationDate < today;
    },
    isK3lExpired(data) {
      console.log('is K3l Exp: ==', data);
      if (!data) return false;
      const today = new Date();
      const expirationDate = new Date(data);
      console.log('k3l expired date', expirationDate < today);
      return expirationDate < today;
    },
    copyToClipboard(id) {
      // Teks yang akan disalin ke clipboard
      const teks = `${process.env.VUE_APP_ISUPPLIER_URL}search-result?vendor=${id}`

      // Buat elemen textarea sementara untuk menampung teks yang akan disalin
      const textarea = document.createElement('textarea')
      textarea.value = teks
      document.body.appendChild(textarea)

      // Pilih teks dalam textarea
      textarea.select()
      textarea.setSelectionRange(0, textarea.value.length)

      // Salin teks ke clipboard
      document.execCommand('copy')

      // Hapus elemen textarea sementara
      document.body.removeChild(textarea)

      // Tampilkan pesan sukses
      alert(`
        Teks berhasil disalin:

        ${teks}
      `)
    },
  },
}
</script>
